var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('help.device_management.description'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }